import { createContext } from 'react';

export interface IMessageContext {
  showMessage: (message: string) => void;
}

const MessageContext = createContext<IMessageContext>(null);

export default MessageContext;
